import axios            from "@/axios/axios";
import createDictionary from "@/helpers/createDictionary";

const defaultColor = "rgba(var(--app-content-color), 1)";
const colors = {
  1: "rgba(var(--app-success), 1)",
  2: "rgba(var(--app-content-color), 1)",
  3: "rgba(var(--app-danger), 1)",
  4: "rgba(var(--app-info), 1)",
  5: "rgba(var(--app-danger), 1)",
  6: "rgba(var(--app-success), 1)",
  7: "rgba(var(--app-danger), 1)",
};
const defaultIcon = "QuestionIcon";
const icons = {
  1: "PowerOnIcon",
  2: "SettingsIcon",
  3: "BrokenDeviceIcon",
  4: "ExchangeIcon",
  5: "ClockIcon",
  6: "CheckIcon",
  7: "PowerIcon",
};

export default createDictionary({
  loadData:          () => axios.get('device_statuses'),
  transformResponse: ( list ) => {
    list.forEach(item => {
      item.color = colors[item.id] || defaultColor;
      item.icon = icons[item.id] || defaultIcon;
    });
    return list;
  },
});
